import 'src/styles/ui/date-tile.css';

import classNames from 'classnames';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * DateTile — compact month/day calendar tile used as the leading visual of
 * list items (events, downtime windows, schedules).
 *
 * @param {Object} props
 * @param {string|Date} props.date - The date to display
 * @param {'amber'|'blue'|'green'|'grey'} props.color - Tile color (e.g. by status)
 * @param {'md'|'sm'} props.size - 'sm' for dense pick rows
 */
const DateTile = ({ date, color, size, className }) => {
  const parsed = dayjs(date);
  return (
    <div
      className={classNames(
        'date-tile',
        `date-tile--${color}`,
        { 'date-tile--sm': size === 'sm' },
        className
      )}
    >
      <div className='date-tile__month'>{parsed.format('MMM')}</div>
      <div className='date-tile__day'>{parsed.format('DD')}</div>
    </div>
  );
};

DateTile.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  color: PropTypes.oneOf(['amber', 'blue', 'green', 'grey']),
  size: PropTypes.oneOf(['md', 'sm']),
  className: PropTypes.string,
};

DateTile.defaultProps = {
  color: 'blue',
  size: 'md',
  className: '',
};

export default DateTile;
